import { CategoryIcons } from '@/components/icons/CategoryIcons';
import { Picture } from '@/components/image/Image';
import { Card } from '@/components/sections/Card';
import { Product } from '@/services/api/contracts/catalog/types';
import { useSelectedFinanceModel } from '@/services/catalogue/useCustomerCatalogueService';
import { usePrintCurrencyStringForCurrentCustomer } from '@/utils/price';
import { FC, FunctionComponent } from 'react';

interface BundleProductQuickDetailsCardProps {
  product: Product;
  count?: number;
  main?: boolean;
}

interface ProductImageProps {
  product: Product;
}

export const ProductImage: FC<ProductImageProps> = ({ product }) => {
  return product.imageUri?.id ? (
    <div className="w-full h-[125px] flex items-center justify-center">
      <Picture image={product.imageUri} containerHeight={125} containerWidth={150}></Picture>
    </div>
  ) : (
    <div className="w-full h-[1250px] [&_svg]:w-[100%] [&_svg]:h-[100%]">
      {CategoryIcons[product.category.description]}
    </div>
  );
};

const BundleProductQuickDetailsCard: FunctionComponent<BundleProductQuickDetailsCardProps> = ({
  product,
  count = 1,
  main = false
}) => {
  const model = useSelectedFinanceModel(product.manufacturer.id, product.category.id);

  const total = (product.price?.price ?? 0) * count;

  const printCurrencyString = usePrintCurrencyStringForCurrentCustomer();
  const price = printCurrencyString(total);

  const pcmTotal = total * (model?.pcmFactor || 0);
  const pcmCost = pcmTotal ? printCurrencyString(pcmTotal) : undefined;

  return (
    <Card className="flex flex-col w-60 justify-center items-center">
      <div className="p-4 w-full h-[125px] flex items-center">
        <ProductImage product={product} />
      </div>
      <div className="p-2 font-medium w-full border-secondary-std border-y">
        <p className="font-semibold leading-tight">{product.name}</p>
        <p className="leading-tight text-gray-500">{main ? 'Main Device' : `Qty: ${count}`}</p>
      </div>
      <p className="p-2 font-medium text-md w-full border-secondary-std border-b text-primary-800 flex space-x-1 items-center">
        <span>{price}</span>
        {pcmCost && <span className="text-sm leading-tight">{`· ${pcmCost} pcm`}</span>}
      </p>
    </Card>
  );
};

export default BundleProductQuickDetailsCard;
